import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    labelErrorToast: (name: string) => string | React.ReactNode;
    labelSuccessToast: (name: string) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** A message to display within a toastwhen an error occurs during the attempted duplication */
            labelErrorToast: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: string) => __intl__.intl().formatMessage({ id: "useDuplicateShare.labelErrorToast?c=3s99d1d93dz92", defaultMessage: "There was an issue attempting to duplicate \"{name}\"" }, { name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** A message to display within a toas twhen the duplication is successful */
            labelSuccessToast: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: string) => __intl__.intl().formatMessage({ id: "useDuplicateShare.labelSuccessToast?c=2g7hb6l3aw3pi", defaultMessage: "Duplicated \"{name}\"" }, { name: name }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
